<template>
  <div>
    <div class="component-header">
      <!-- 背景图 开始 -->
      <img src="../assets/images/bg.png" class="bgbanner" />
      <!-- 背景图 结束 -->
    </div>
    <div
      class="page-index "
      :class="{
        maincontenttopmobile: isphone,
        maincontenttoppc: isphone == false
      }"
    >
      <!-- 顶部献花视频直播 开始 -->
      <Xianhua :jxhl="jxhl" />
      <!-- 顶部献花视频直播 结束 -->

      <!-- 图组纪实·缅怀英烈 开始 -->
      <MianHuai :mhyl="mhyl" />
      <!-- 图组纪实·缅怀英烈 结束 -->

      <!-- 烈士公祭·最新资讯  开始 -->
      <ZiXun :zxzx="zxzx" :zxzxnum="zxzxnum" />
      <!-- 烈士公祭·最新资讯  结束 -->

      <!-- 祭奠英烈·精神传承 开始 -->
      <ChuanCheng :gdgjhd="gdgjhd" :wlsbss="wlsbss" :jsccnum="jsccnum" />
      <!-- 祭奠英烈·精神传承 结束 -->

      <!-- 全民公祭·致敬英雄 开始 -->
      <ZhiJing :zjyl="zjyl" />
      <!-- 全民公祭·致敬英雄 结束 -->

      <!-- 红色印记·英雄丰碑 开始 -->
      <FengBei />
      <!-- 红色印记·英雄丰碑 结束 -->

      <!-- 英烈之名·共同捍卫 开始 -->
      <HanWei :zcfg="zcfg" :jyzf="jyzf" :gthwnum="gthwnum" />
      <!-- 英烈之名·共同捍卫 结束 -->
    </div>
  </div>
</template>

<script>
import { getDeedsdatas } from "@/api/index";
import WebBg from "../components/bg.vue"; // Bgimg
import Xianhua from "../components/xianhua.vue"; // 顶部献花视频直播
import MianHuai from "../components/mianhuai.vue"; // 图组纪实·缅怀英烈
import ZiXun from "../components/zixun.vue"; // 烈士公祭·最新资讯
import ChuanCheng from "../components/chuancheng.vue"; // 祭奠英烈·精神传承
import ZhiJing from "../components/zhijing.vue"; // 全民公祭·致敬英雄
import FengBei from "../components/fengbei.vue"; // 红色印记·英雄丰碑
import HanWei from "../components/hanwei.vue"; // 英烈之名·共同捍卫
export default {
  name: "PageIndex",
  components: {
    WebBg,
    Xianhua,
    MianHuai,
    ZiXun,
    ChuanCheng,
    ZhiJing,
    FengBei,
    HanWei
  },
  data() {
    return {
      isphone: false,
      jxhl: [], //敬献花篮仪式
      mhyl: [], //缅怀英烈
      zxzx: [], //最新资讯
      gdgjhd: [], //各地公祭活动
      wlsbss: [], //为烈属办实事
      zcfg: [], //政策法规
      jyzf: [], //经验做法
      zjyl: [], // 致敬英烈
      // 测试环境
      // jsccnum: 139,
      // gthwnum: 141,
      // jxhlnum: 136,
      // mhylnum: 137,
      // zxzxnum: 138,
      // gdgjhdnum: 142,
      // wlsbsnum: 143,
      // zcfgnum: 144,
      // jyzfnum: 145,
      // zjylnum: 140

      // 正式环境
      jsccnum: 192,
      gthwnum: 196,
      jxhlnum: 189,
      mhylnum: 190,
      zxzxnum: 191,
      gdgjhdnum: 193,
      wlsbsnum: 194,
      zcfgnum: 197,
      jyzfnum: 198,
      zjylnum: 195
    };
  },
  computed: {},
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
    // 敬献花篮仪式
    getDeedsdatas(this.jxhlnum).then(res => {
      // 取数组的前1条
      var datas = res.slice(0, 1);
      this.jxhl = datas[0];
    });
    // 缅怀英烈
    getDeedsdatas(this.mhylnum).then(res => {
      // 取数组的前10条
      this.mhyl = res.slice(0, 10);
    });
    // 最新资讯
    getDeedsdatas(this.zxzxnum).then(res => {
      // 取数组的前12条
      this.zxzx = res.slice(0, 12);
    });

    // 各地公祭活动
    getDeedsdatas(this.gdgjhdnum).then(res => {
      // 取数组的前6条
      this.gdgjhd = res.slice(0, 6);
      console.log("gdgjhd：", this.gdgjhd);
    });
    // 为烈属办实事
    getDeedsdatas(this.wlsbsnum).then(res => {
      // 取数组的前6条
      this.wlsbss = res.slice(0, 6);
    });

    // 政策法规
    getDeedsdatas(this.zcfgnum).then(res => {
      // 取数组的前12条
      this.zcfg = res.slice(0, 12);
    });
    // 经验做法
    getDeedsdatas(this.jyzfnum).then(res => {
      // 取数组的前12条
      this.jyzf = res.slice(0, 12);
    });
    // 致敬英烈
    getDeedsdatas(this.zjylnum).then(res => {
      // 取数组的前12条
      this.zjyl = res.slice(0, 30);
      console.log("zjyl", this.zjyl);
    });
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 切换烈士列表页码
     * @param {Number} currentPage : 切换后的页码
     * ##########################################################################################
     */

    changeCurrentPage(currentPage) {
      this.currentPage = currentPage;
      this.getList();
      console.log("最新页码：" + currentPage);
    },

    /**
     * ##########################################################################################
     * @description 请求 “烈士纪念设施分布” 模块的数据
     * ##########################################################################################
     */
    queryMapChartData() {
      var that = this;
      // 模拟请求
      const timer = setTimeout(() => {
        // 接口请求到的数据
        // name : 城市名称
        // total: 烈士纪念设施数量
        const responseData = [];
        // 烈士纪念设施分布
        getdistribution().then(res => {
          console.log("烈士纪念设施分布：", res);
          // 数据请求成功后初始化图表
          this.initMapChart(res);
        });

        // 如果请求到底数据中没有 name、total 字段，需要处理一下
        // responseData.forEach(el => {
        //   el.name = el.xx
        //   el.total = el.xx
        // })

        // 清除定时器
        clearTimeout(timer);
      }, 1000);
    },

    /**
     * ##########################################################################################
     * @description 调用著名烈士列表接口
     * ##########################################################################################
     */

    getList() {
      // TODO: request login api
      var types = "207d0d1da40742fa851616985efd3f0e";
      var data = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: types
      };
      this.loading = true;
      martyrList(data, types).then(res => {
        console.log("res：", res);
        // if (res.code) {
        //   if (res.code == 200) {
        //     this.martyrsTotal = res.total;
        //     this.martyrsList = res.rows;
        //     this.loading = false;
        //   } else {
        //     this.$message.error(res.msg);
        //     this.loading = false;
        //   }
        // } else {
        this.martyrsTotal = res.length;
        this.martyrsList = res.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
        this.loading = false;
        // }
      });
    }
  }
};
</script>

<!-- 覆盖ElementUI样式 -->
<style type="text/css">
.bgbanner {
  display: block;
  width: 100%;
  height: 5200px;
}
.def-hover-trs {
  transition: all 0.2s;
}
:root {
  --main-color: #d0151b;
  --main-linear-gradient: linear-gradient(0deg, #aa233d 0%, #e53b45 100%);
  --main-yellow: #f7f499;
  --main-linear-gradient-yellow: linear-gradient(
    0deg,
    #ec9616 0%,
    #ffeeb4 100%
  );
  --main-linear-gradient-two: linear-gradient(0deg, #c00304 0%, #f26363 100%);
}
/* 标题显示一行 */
.titlehang1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: justify;
  word-break: break-all;
}
/* 标题显示2行 */
.titlehang2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: justify;
  word-break: break-all;
}
.contenthang {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.contenthangmobile {
  line-height: 1.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.noselect {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
li {
  list-style: none;
}
/* li:before {
  content: "●";
  color: #ddd;
  float: left;
}
li:before:hover {
  content: "●";
  color: red;
} */
.maincontenttoppc {
  width: 100%;
  position: absolute;
  /* pc端 */
  top: 860px;
}
.maincontenttopmobile {
  width: 100%;
  position: absolute;
  /* 手机端 */
  top: 855px;
}
.main-content {
  height: 2750px;
  z-index: 1;
  /* left: 18.43%; */
  /* background-image: url(../assets/images/bg.png); */
}
.component-news-list {
  margin: 0 auto;
}
/* 栏目标题样式开始 */
.title {
  height: 45px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  top: 20px;
  border-bottom: 1px solid #ddd;
}
.title .bigtitle {
  font-size: 36px;
  top: 20px;
  font-family: "思源宋体";
  font-weight: 700;
}
.title .more {
  padding: 14px 0px;
  font-size: 14px;
  color: #656565;
}
.title .more:hover {
  cursor: pointer;
  color: var(--main-color);
}
.title .titlestyle {
  color: #000;
}
.title .titlestyle:before {
  content: "";
  position: absolute;
  top: auto;
  bottom: -3px;
  right: auto;
  height: 4px;
  width: 300px;
  background-color: var(--main-color);
}
/* 栏目标题样式结束 */

/* tab导航 */

.tab {
  height: 40px;
  font-size: 36px;
  top: 36px;
  /* background-color: rgb(197, 223, 223); */
}
.tab {
  font-size: 24px;
  font-family: "思源宋体";
}

.maincontenttoppc {
  width: 100%;
  position: absolute;
  /* pc端 */
  top: 860px;
}
.maincontenttoppc .tab ul {
  width: 380px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.maincontenttoppc .tab ul li {
  /* padding: 10px 20px; */
  height: 33px;
  line-height: 33px;
  width: 185px;
  text-align: center;
}

.maincontenttopmobile {
  width: 100%;
  position: absolute;
  /* pc端 */
  /* top: 860px; */
  top: 25%;
}
.maincontenttopmobile .tab ul {
  width: 820px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.maincontenttopmobile .tab ul li {
  /* padding: 10px 20px; */
  height: 33px;
  line-height: 33px;
  width: 400px;
  text-align: center;
}

.tab ul li:hover {
  cursor: pointer;
  background-color: var(--main-color);
  color: #fff;
}
.tabnoactive {
  background-color: #ddd;
  color: #000;
}
.tabactive {
  background-color: var(--main-color);
  color: #fff;
}
/* .tab ul li:first-child {
  background-color: var(--main-color);
  color: #fff;
}
 */
</style>



// WEBPACK FOOTER //
// src/pages/index.vue